import create from 'zustand';
import { postVirtualAmendOrder, postVirtualOrder } from '../api/order';
import {
  VirtualAmendOrderPayload,
  VirtualCreateOrderPayload,
} from '../types/api/order';

interface State {
  isLoading?: boolean;
  message?: string;
  data?: string[];
  error?: string;
}

interface Action {
  createVirtualOrder(
    orderType: 'buy' | 'sell',
    symbol: string,
    form: VirtualCreateOrderPayload,
    isAmend?: boolean,
    orderId?: string,
  ): Promise<void>;

  createVirtualAmendOrder(form: VirtualAmendOrderPayload): Promise<void>;
}

export const useVirtualOrderStore = create<State & Action>((set, get) => ({
  isLoading: false,
  message: '',
  data: [],
  error: '',

  async createVirtualOrder(orderType, symbol, form) {
    try {
      const { isLoading } = get();
      if (isLoading) {
        return;
      }

      set({ isLoading: true });

      const response = await postVirtualOrder(orderType, symbol, form);
      const { data } = response.data;

      const orderIds = 'order_id' in data ? [data.order_id] : data.order_ids;

      set({ isLoading: false, data: orderIds });
    } catch (e) {
      set({ isLoading: false });
      Promise.reject(e);
    }
  },

  async createVirtualAmendOrder(form) {
    try {
      const { isLoading } = get();
      if (isLoading) {
        return;
      }

      set({ isLoading: true });

      const response = await postVirtualAmendOrder(form);
      const { data } = response.data;

      set({ isLoading: false, data: [data.order_id] });
    } catch (e) {
      set({ isLoading: false });
      Promise.reject(e);
    }
  },
}));
